import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetMemberModel } from "@factory/model/query-model-member";
import { memberFormDefault } from "./form.default";
import { MemberFormSchema } from "./form.rule";

export const useFormDefaultMember = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetMemberModel | undefined) => {
    return !cachedValue
      ? memberFormDefault
      : ({
          tenant: cachedValue.tenant,
          parentCode: cachedValue.parent_code,
          firstName: cachedValue.first_name,
          middleName: cachedValue.middle_name,
          lastName: cachedValue.last_name,
          email: cachedValue.email,
          gender: cachedValue.gender,
          birthday: cachedValue.birthday,
          mobileNumber: cachedValue.mobile_number,
          avatar: cachedValue.avatar,
          emergencyContact_1Number: cachedValue.emergency_contact_1_number,
          emergencyContact_1Name: cachedValue.emergency_contact_1_name,
          emergencyContact_1Relationship:
            cachedValue.emergency_contact_1_relationship,
          emergencyContact_2Number: cachedValue.emergency_contact_2_number,
          emergencyContact_2Name: cachedValue.emergency_contact_2_name,
          emergencyContact_2Relationship:
            cachedValue.emergency_contact_2_relationship,
          streetName: cachedValue.street_name,
          subdivision: cachedValue.subdivision,
          zone: cachedValue.zone,
          sitio: cachedValue.sitio,
          purok: cachedValue.purok,
          barangay: cachedValue.barangay,
          municipality: cachedValue.municipality,
          province: cachedValue.province,
          region: cachedValue.region,
          country: cachedValue.country,
          zip: cachedValue.zip,
          longitude: cachedValue.longitude,
          latitude: cachedValue.latitude,
          isChild: Boolean(cachedValue.is_child),
          photo: "",
          age: 0,
        } as MemberFormSchema);
  };

  return {
    getDefault,
  };
};
